export const USER_PROFILE_ENTITY = {
    name: "User Profile",
    icon: "fa-regular fa-user",
    checked: true,
    disabled: true,
    isStatic: true,
    isUserEntity: true,
    attributesLoading: false,
    attributes: [
        {
            language_key: "first_name",
            name: "First Name",
            sysName: "firstname",
            type: "String",
            picklist: null,
            required: true,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
        {
            language_key: "last_name",
            name: "Last Name",
            sysName: "lastname",
            type: "String",
            picklist: null,
            required: true,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
        {
            language_key: "display_name",
            name: "Display Name",
            sysName: "displayname",
            type: "String",
            picklist: null,
            required: true,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
        {
            language_key: "email",
            name: "Email",
            sysName: "email",
            type: "String",
            picklist: null,
            required: false,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
        {
            language_key: "phone",
            name: "Phone",
            sysName: "phone",
            type: "String",
            picklist: null,
            required: false,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
        {
            language_key: "country",
            name: "Country",
            sysName: "country",
            type: "String",
            picklist: null,
            required: false,
            unique: false,
            checked: false,
            selected: true,
            disabled: true,
            isAzureAttribute: true
        },
    ],
    pageConfiguration: {
        shouldCreateTable: true,
        shouldCreateSplitView: true,
        shouldCreateKanban: false,
        shouldCreateCards: false,
        shouldCreateCalendar: false,
        shouldCreateGanttChart: false,
        shouldCreateDetailsView: true,
        shouldCreateEditRecord: true,
        shouldCreateNewRecord: false,
        isKanbanDisabled: true,
        isCalendarDisabled: true,
        isGanttChartDisabled: true
    }
}

export const USER_TO_USER_RELATION = {
    from: USER_PROFILE_ENTITY.name,
    to: USER_PROFILE_ENTITY.name,
    cardinality: "1-*",
    showReferenceAttribute: true,
    referenceAttribute: "Display Name",
    checked: false,
    selected: true,
    isStatic: true,
    isRequired: true,
    isUserProfileRelation: true
};

export const DEFAULT_PAGE_CONFIGURATION = {
    shouldCreateTable: true,
    shouldCreateSplitView: true,
    shouldCreateKanban: false,
    shouldCreateCards: false,
    shouldCreateCalendar: false,
    shouldCreateGanttChart: false,
    shouldCreateDetailsView: true,
    shouldCreateEditRecord: true,
    shouldCreateNewRecord: true,
    isKanbanDisabled: false,
    isCalendarDisabled: false,
    isGanttChartDisabled: false
}

export function getUserProfileEntityWithTranslation(t) {
    return {
        ...USER_PROFILE_ENTITY,
        name: t("user_profile.entity_name"),
        attributes: USER_PROFILE_ENTITY.attributes.map(attribute => {
            return {
                ...attribute,
                name: t(`user_profile.attribute_labels.${attribute.language_key}`)
            }
        })
    }
}